import { render, staticRenderFns } from "./OfficesDeliveryDestinationsDetail.vue?vue&type=template&id=356f0924&scoped=true&"
import script from "./OfficesDeliveryDestinationsDetail.vue?vue&type=script&lang=js&"
export * from "./OfficesDeliveryDestinationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfficesDeliveryDestinationsDetail.vue?vue&type=style&index=0&id=356f0924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f0924",
  null
  
)

export default component.exports